// hooks/useFetchStatistics.ts
import { useState, useEffect } from "react";
import axios from "axios";
import { Statistics } from "../../const/statistic.const";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

const useFetchMonthStatistics = (token: string) => {
      const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [monthStatistics, setMonthStatistics] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | undefined | null>(null);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
                    const tk = await getAccessTokenSilently();
 
        const response = await axios.get<{ data: any }>(
          `${apiUrl}/api/v1/statistics/month-transaction`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
            },
          }
        );
        setMonthStatistics(response.data.data);
      } catch (err) {
        setError("Error fetching statistics");
      } finally {
        setLoading(false);
      }
    };

    fetchStatistics();
  }, [token]);

  return { monthStatistics, loading, error };
};

export default useFetchMonthStatistics;
